import { styled } from "@l2r-front/l2r-ui"

import { LoginFormPost } from "../../forms/LoginForm"

export const PageWrapper = styled("div")({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    width: "100%",
})

export const LoginForm = styled(LoginFormPost)(({ theme }) => ({
    marginBottom: theme.spacing(1),
}))
